async function isAuthenticated(context) {
  try {
    const { localRepo } = context
    const userData = await localRepo.get()
    return !!userData?.id
  } catch (error) {
    console.log('🚀 ~ isAuthenticated ~ error:', error)
    return false
  }
}

export default isAuthenticated
